import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgbPopoverModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SvgIconsModule } from '@anecdotes/design-system/svg-icons';
import { RouterModule } from '@angular/router';
import { WindowHelperService } from '@anecdotes/utils';
import { ButtonsModule } from '../../../buttons/src';
import { ScrollingButtonComponent } from './scrolling-buttons/components';
import {
  ShowOnScreenDirective,
  HideOnScreenDirective,
  OpenTooltipWhenOverflowedAndHoveredDirective,
  KeepTooltipOrPopoverOnHoverDirective,
  HtmlElementReferenceDirective,
  DisplayingElementsNumberDirective,
  ScrollingButtonsDirective,
  TooltipWithContextDirective,
  ShouldOpenTooltipDirective,
  EllipsisWithCountDirective,
  NgVarDirective,
  DigitOnlyDirective,
} from './index';

@NgModule({
  imports: [
    ButtonsModule,
    CommonModule,
    TranslateModule.forChild(),
    NgbTooltipModule,
    SvgIconsModule,
    RouterModule,
    NgbPopoverModule,
  ],
  declarations: [
    KeepTooltipOrPopoverOnHoverDirective,
    NgVarDirective,
    OpenTooltipWhenOverflowedAndHoveredDirective,
    HtmlElementReferenceDirective,
    ScrollingButtonsDirective,
    DisplayingElementsNumberDirective,
    ScrollingButtonComponent,
    TooltipWithContextDirective,
    ShouldOpenTooltipDirective,
    EllipsisWithCountDirective,
    HideOnScreenDirective,
    ShowOnScreenDirective,
    DigitOnlyDirective,
  ],
  exports: [
    KeepTooltipOrPopoverOnHoverDirective,
    NgVarDirective,
    OpenTooltipWhenOverflowedAndHoveredDirective,
    HtmlElementReferenceDirective,
    ScrollingButtonsDirective,
    DisplayingElementsNumberDirective,
    TooltipWithContextDirective,
    ShouldOpenTooltipDirective,
    EllipsisWithCountDirective,
    HideOnScreenDirective,
    ShowOnScreenDirective,
    DigitOnlyDirective,
  ],
  providers: [WindowHelperService],
})
export class DirectivesModule {}
